<script>
  import { onMount } from 'svelte'
  import { resolveTheme, toggleTheme } from '../lib/theme.js'

  export let variant = 'header' // header | float | nav

  let theme =
    typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'dark'
      ? 'dark'
      : 'light'

  onMount(() => {
    theme = resolveTheme()
  })

  function onToggle() {
    theme = toggleTheme()
  }

  $: label = theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'
  $: glyph = theme === 'dark' ? '☀' : '☾'
</script>

<button
  type="button"
  class="pm-theme-toggle"
  class:pm-theme-toggle--float={variant === 'float'}
  class:pm-theme-toggle--nav={variant === 'nav'}
  on:click={onToggle}
  title={label}
  aria-label={label}
>
  <span class="pm-theme-toggle__glyph" aria-hidden="true">{glyph}</span>
  {#if variant === 'nav'}
    <span class="pm-theme-toggle__text">{theme === 'dark' ? 'Светлая' : 'Тёмная'}</span>
  {/if}
</button>
